import { Box } from '@wishket/design-system';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface SkeletonProps {
  className?: string;
  grayScale?: number;
}

const Skeleton = ({
  children,
  className,
  grayScale = 50,
}: PropsWithChildren<SkeletonProps>) => {
  const hasChildren = !!children;
  const defaultSkeletonClass = 'w-full rounded-3xl';
  const grayScaleClass: Record<number, string> = {
    50: 'bg-w-gray-50',
    100: 'bg-w-gray-100',
    200: 'bg-w-gray-200',
  };
  return (
    <Box
      className={twMerge(
        'animate-pulse',
        !hasChildren && defaultSkeletonClass,
        !hasChildren && grayScaleClass[grayScale],
        className
      )}
    >
      {children}
    </Box>
  );
};

export default Skeleton;
